module.exports = __webpack_public_path__ + "img/popup-cont.bdf06227.png";